import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";

import GenericChartComponent from "../GenericChartComponent";
import displayValuesFor from "./displayValuesFor";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined, noop } from "../utils";

class ATRStopTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  resolveValues(currentItem) {
    const { yAccessor } = this.props;
    if (!currentItem || !yAccessor)
      return { buy: undefined, sell: undefined, trend: undefined };
    const node = yAccessor(currentItem);
    if (!node) return { buy: undefined, sell: undefined, trend: undefined };
    const { buy, sell, value, trend } = node;
    return {
      buy: isDefined(buy) ? buy : undefined,
      sell: isDefined(sell) ? sell : undefined,
      value: isDefined(value) ? value : isDefined(buy) ? buy : sell,
      trend,
    };
  }

  renderSVG(moreProps) {
    const {
      origin: originProp,
      className,
      fontFamily,
      fontSize,
      labelFill,
      valueFill,
      yDisplayFormat,
      displayValuesFor: displayValuesForProp,
      options,
      onClick,
      buyLabel,
      sellLabel,
      buyColor,
      sellColor,
    } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const currentItem = displayValuesForProp(this.props, moreProps);
    const { buy, sell, value, trend } = this.resolveValues(currentItem);

    const valueText = isDefined(value) ? yDisplayFormat(value) : "n/a";
    const buyText = isDefined(buy) ? yDisplayFormat(buy) : "-";
    const sellText = isDefined(sell) ? yDisplayFormat(sell) : "-";

    const activeLabel =
      trend === "buy"
        ? buyLabel
        : trend === "sell"
          ? sellLabel
          : isDefined(buy)
            ? buyLabel
            : sellLabel;
    const activeColor =
      trend === "buy"
        ? buyColor || valueFill
        : trend === "sell"
          ? sellColor || valueFill
          : valueFill;

    const optionSummary = options
      ? `(${options.period}, ${options.multiplier})`
      : "";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-atrstop"
      >
        <ToolTipText fontFamily={fontFamily} fontSize={fontSize} x={0} y={0}>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{`ATR Stop${optionSummary ? ` ${optionSummary}` : ""}: `}</ToolTipTSpanLabel>
          <tspan fill={activeColor}>{`${valueText} `}</tspan>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{`${buyLabel}: `}</ToolTipTSpanLabel>
          <tspan fill={buyColor || valueFill}>{`${buyText} `}</tspan>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{`${sellLabel}: `}</ToolTipTSpanLabel>
          <tspan fill={sellColor || valueFill}>{`${sellText} `}</tspan>
          {activeLabel ? (
            <ToolTipTSpanLabel
              fill={labelFill}
            >{`[${activeLabel}]`}</ToolTipTSpanLabel>
          ) : null}
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

ATRStopTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  valueFill: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  yDisplayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  options: PropTypes.object,
  onClick: PropTypes.func,
  buyLabel: PropTypes.string,
  sellLabel: PropTypes.string,
  buyColor: PropTypes.string,
  sellColor: PropTypes.string,
};

ATRStopTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 11,
  labelFill: "#4682B4",
  valueFill: "#000000",
  yDisplayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  options: undefined,
  onClick: noop,
  buyLabel: "ATR+",
  sellLabel: "ATR-",
  buyColor: undefined,
  sellColor: undefined,
};

export default ATRStopTooltip;
